import { TestBed, ComponentFixture } from '@angular/core/testing';
export function createGenericTestComponent<T>(
  html: string,
  type: { new (...args: unknown[]): T }
): ComponentFixture<T> {
  TestBed.overrideComponent(type, { set: { template: html } });
  const fixture = TestBed.createComponent(type);
  fixture.detectChanges();
  return fixture;
}
